import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { FormGroup, Radio, ControlLabel } from "react-bootstrap";

import { validateCheckOnlyModified } from "./SettingsValue";

export const RadioOption = props => (
	<Radio name={props.prop} inline value={props.value}
		checked={props.local[props.prop].value === props.value}
		onChange={props.handleChange}>
		<FormattedMessage id={props.i18n_key} />
	</Radio>
);

RadioOption.propTypes = {
	i18n_key: PropTypes.string.isRequired,
	prop: PropTypes.string.isRequired,
	value: PropTypes.any.isRequired,
	local: PropTypes.object.isRequired,
	handleChange: PropTypes.func.isRequired
};

const RadioControl = props => (
	<FormGroup validationState={validateCheckOnlyModified(props.local, props.prop)}>
		<ControlLabel>
			<FormattedMessage id={props.i18n_key} />
		</ControlLabel>
		{props.children}
	</FormGroup>
);

RadioControl.propTypes = {
	i18n_key: PropTypes.string.isRequired,
	prop: PropTypes.string.isRequired,
	local: PropTypes.object.isRequired,
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.element),
		PropTypes.element
	])
};

export default RadioControl;
